// extracted by mini-css-extract-plugin
module.exports = {"select_wrap":"TreeSelect_select_wrap__H82Mi","border":"TreeSelect_border__dqOGW","arrow_down":"TreeSelect_arrow_down__sagKL","clear_icon":"TreeSelect_clear_icon__PrLpb"};